<template>
  <v-app>
    <v-app-bar app hide-on-scroll :color="app_bar_color" height="80">
      <v-img src="@/assets/logo.png" contain max-width="200" @click="goToHome" />

      <v-spacer></v-spacer>

      <div class="d-block d-md-none">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon class="black--text">mdi-menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item :to="{ name: 'home' }" class="text-secondary bolder">
              <v-list-item-title>DASHBOARD</v-list-item-title>
            </v-list-item>

            <template v-if="userData">
              <v-list-item :to="{ name: 'profile' }" class="text-secondary bolder">
                <v-list-item-title>PROFILE</v-list-item-title>
              </v-list-item>

              <v-list-item :to="{ name: 'shop_flings' }" class="text-secondary bolder">
                <v-badge
                  v-if="userData.unused_tokens"
                  color="green"
                  :content="userData.unused_tokens"
                  inline
                >
                  <v-list-item-title>SHOP FLINGS</v-list-item-title>
                </v-badge>
                <v-list-item-title v-else>SHOP FLINGS</v-list-item-title>
              </v-list-item>

              <v-list-item
                :href="`https://www.faithfulfling.com/${
                  userData.role === 'husband' ? 'guys' : 'ladies'
                }-tips/`"
                class="text-secondary bolder"
              >
                <v-list-item-title>TIPS FOR SUCCESS</v-list-item-title>
              </v-list-item>
            </template>

            <template v-if="!userData">
              <v-list-item :to="{ name: 'login' }" class="text-secondary bolder">
                <v-list-item-title>LOGIN</v-list-item-title>
              </v-list-item>

              <v-list-item :to="{ name: 'sign_up' }" class="text-secondary bolder">
                <v-list-item-title>SIGN UP</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item class="text-secondary bolder" @click="logUserOut('redirect')">
              <v-list-item-title>LOGOUT</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="d-none d-md-block">
        <v-btn :to="{ name: 'home' }" class="mr-2" text> Dashboard </v-btn>

        <template v-if="userData">
          <v-btn :to="{ name: 'profile' }" class="mr-2" text> Profile </v-btn>

          <v-btn :to="{ name: 'shop_flings' }" class="mr-2" text>
            <v-badge
              v-if="userData.unused_tokens"
              color="green"
              :content="userData.unused_tokens"
              :offset-x="-5"
              :offset-y="-3"
            >
              SHOP FLINGS
            </v-badge>
            <template v-else>SHOP FLINGS</template>
          </v-btn>

          <v-btn
            :href="`https://www.faithfulfling.com/${
              userData.role === 'husband' ? 'guys' : 'ladies'
            }-tips/`"
            class="mr-2"
            text
          >
            Tips For Success
          </v-btn>
        </template>

        <template v-if="!userData">
          <v-btn :to="{ name: 'login' }" class="mr-2" text> Login </v-btn>

          <v-btn :to="{ name: 'sign_up' }" text> Sign Up </v-btn>
        </template>
        <v-btn v-else text @click="logUserOut('redirect')"> Logout </v-btn>
      </div>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      app_bar_color: "var(--header)",
    };
  },
  async created() {
    if (window.innerWidth < 960) {
      this.app_bar_color = "white";
    }

    if (this.userData && this.userData.drf_token) {
      this.$store.commit("userData", this.userData);

      const responseData = await this.api({
        url: "users/refresh/",
        method: "GET",
      });

      if (responseData.status === 200) {
        this.$store.commit("userData", responseData.body);
      }
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const afid = urlParams.get("afid");
    if (afid) {
      document.cookie = `faithfulflingAfid=${afid}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/;`;
    }
  },
  methods: {
    goToHome() {
      window.location.href = "https://faithfulfling.com/";
    },
  },
};
</script>

<style>
@font-face {
  font-family: "Raleway";
  font-weight: 100;
  src: url("./assets/fonts/Raleway-Thin.ttf") format("truetype");
}
@font-face {
  font-family: "Raleway";
  font-weight: 200;
  src: url("./assets/fonts/Raleway-ExtraLight.ttf") format("truetype");
}
@font-face {
  font-family: "Raleway";
  font-weight: 300;
  src: url("./assets/fonts/Raleway-Light.ttf") format("truetype");
}
@font-face {
  font-family: "Raleway";
  font-weight: 400;
  src: url("./assets/fonts/Raleway-Light.ttf") format("truetype");
}
@font-face {
  font-family: "Raleway";
  font-weight: 500;
  src: url("./assets/fonts/Raleway-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Raleway";
  font-weight: 600;
  src: url("./assets/fonts/Raleway-Medium.ttf") format("truetype");
}
@font-face {
  font-family: "Raleway";
  font-weight: 700;
  src: url("./assets/fonts/Raleway-SemiBold.ttf") format("truetype");
}
@font-face {
  font-family: "Raleway";
  font-weight: 800;
  src: url("./assets/fonts/Raleway-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "Raleway";
  font-weight: 900;
  src: url("./assets/fonts/Raleway-ExtraBold.ttf") format("truetype");
}
@font-face {
  font-family: "Asterism";
  font-weight: 500;
  src: url("./assets/fonts/Asterism.ttf");
}
</style>

<style lang="scss">
:root {
  --green: #244d3c;
  --gold: #b28c67;
  --pink: #f9f5f1;
  --red: #280400;
  --pink-background: #f9f5f1b5;
  --header: #eee6de;
  --text: #280400;
  --text-muted: rgba(40, 38, 37, 0.4);
  --box-shadow: 0 1px 0 rgb(0 0 0 / 10%);
  --box-shadow-card: 0 0.5px 0 1.25px rgb(0 0 0 / 10%);
}

main {
  background-color: var(--pink-background);
}

.home,
.login,
.sign_up,
.password_reset,
.edit-profile,
.edit-card,
.edit-package,
.purchase-flings {
  padding-top: 40px;
}

// Vuetify changes
.v-app-bar {
  box-shadow: var(--box-shadow) !important;
}

.v-card {
  box-shadow: var(--box-shadow-card) !important;
}

.v-btn {
  font-family: "Raleway", Helvetica, Arial, Lucida, sans-serif;
  font-weight: 600 !important;
}

.text-secondary {
  font-family: "Raleway", Helvetica, Arial, Lucida, sans-serif;
  font-weight: 500;

  &.fancy {
    font-family: "Asterism", Helvetica, Arial, Lucida, sans-serif;
  }

  &.xxl {
    font-size: 100px;
  }

  &.xl {
    font-size: 36px;
  }

  &.lg {
    font-size: 30px;
  }

  &.md {
    font-size: 18px;
  }

  &.sm {
    font-size: 12px;
  }

  &.bolder {
    font-weight: 600;
    letter-spacing: 0.5px;
  }
}

.v-badge__badge {
  padding: 3px !important;
}
</style>
